import bgImage from 'components/AuthModal/images/bg.jpg'

const CONTAINER_STYLES =
  'relative flex flex-col items-center px-4 bg-black rounded-xl rounded-b-none sm:rounded-b-xl sm:border-opacity-70 sm:rounded-xl sm:border-solid sm:border-cinder sm:w-screen sm:max-w-lg sm:px-6'
const CONTAINER = `${CONTAINER_STYLES} py-7 sm:h-100`
const PROFILE_CONTAINER = `relative ${CONTAINER_STYLES} py-10 pt-20 h-full z-10 sm:py-10 sm:h-128 sm:pt-14`

export const PROFILE_CONTAINER_STYLES = {
  backgroundImage: `url(${bgImage})`,
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
}

export const BASE_INPUT =
  'w-full px-7 py-4 text-base text-white font-tomatoGrotesk-reg border-none rounded-full border-opacity-10 flex items-center justify-between outline-none focus:border-opacity-100'
const INPUT = `${BASE_INPUT} bg-woodsmokeBlack`
const COLORS = {
  REGENT_GRAY: '#8394A3',
}

const OVERLAY = 'flex flex-col justify-end sm:justify-center'

export { CONTAINER, PROFILE_CONTAINER, INPUT, COLORS, OVERLAY }
